export default import.meta.ROLLUP_FILE_URL_skI2rEQGUYdv1ifOBsMiMQ